import { render, staticRenderFns } from "./AirPage.vue?vue&type=template&id=34a19ac2&scoped=true&"
import script from "./AirPage.vue?vue&type=script&lang=js&"
export * from "./AirPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a19ac2",
  null
  
)

export default component.exports